import { useTranslation } from "react-i18next";
import type { Plan } from "types";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import { useMemo } from "react";
import PlanForm from "./PlanForm";

function SidebarPlanForm({ ...props }: any) {
  return <CrudEdit collectionName="plans" Form={PlanForm} {...props} />;
}

function Plans() {
  const { t } = useTranslation();

  const columns: TableColumn<Plan>[] = useMemo(
    () => [
      {
        field: "name",
        header: t("plans.name"),
        sortable: true,
        renderType: "bold",
      },
    ],
    [t],
  );

  const actions: CrudHeaderAction[] = useMemo(() => {
    return [
      {
        title: t("common.new"),
        icon: "PlusCircleIconSolid",
        action: "openSidebar",
        type: "white",
        className: "flex flex-row-reverse",
      },
    ];
  }, [t]);

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "name$containsi",
        label: t("plans.name"),
        renderType: "input",
        icon: "TbGauge",
      },
    ];
  }, [t]);

  return (
    <CrudList
      collectionName="plans"
      columns={columns}
      headerActions={actions}
      filters={filters}
      defaultSort="name:ASC"
      canDelete
      canEdit
      formMode="sidebar"
      SidebarFormComponent={SidebarPlanForm}
      actionsHeader=""
      className="pt-2 px-4"
    />
  );
}

export default Plans;
